import React from 'react';
import IconMylistWhite from '../../assets/images/common/icon-mylist-white.svg';

type SearchResultBottomProps = {
    moveEditDevice: () => void;
};

export const SearchResultBottom: React.FC<SearchResultBottomProps> = ({ moveEditDevice }) => {
    return (
        <>
            <div className='container'>
                <div className='columns'>
                    <div className='column'>
                        <div className='bottom_cta--next'>
                            <p className='bottom_cta--next_text'>
                                保存した機器の一覧から
                                <br className='is-hidden-tablet' />
                                保有機器の編集を行ってください。
                            </p>
                            <a id='testButton' className='button is-dl_blue' onClick={moveEditDevice}>
                                見積り機器の編集
                                <span className='icon is-small'>
                                    <img src={IconMylistWhite} alt='' />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
